/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsluga filtrowania
 *
 * @export
 * @class Filtering
 * @extends {Pagination}
 */
import { Pagination } from "./Pagination.class";

export class Filtering extends Pagination {
	constructor() {
		super();
		this.checkboxFilters = null;
		this.minPriceInput = null;
		this.maxPriceInput = null;
		this.minPriceRangeInput = null;
		this.maxPriceRangeInput = null;
		this.price = {
			min: null,
			setMin: null,
			max: null,
			setMax: null
		};
		this.filtersCont = '#productsFilters';
		this.desktopContId = '#productsSidePanel';
		this.mobileContId = '#mobileFilteringData';
		this.mobileBtnsContId = '#mobileFilteringBtns';
		this.clearFiltersBtn = null;

		this.temporaryFilteringUrl = null;
	}
	// ****************************************************************************************************
	// inicjacja filtrowania
	// ****************************************************************************************************
	initFiltering() {
		var that = this;
		that.initCheckboxFilters();
		that.initPriceFilters();
		that.initShowHideFiltersBtn();
		that.initClearFiltersBtn();
		that.adjustFilteringToViewKind();
		$('#mobileApplyFilters').on('click', function () { that.applyFilters(); });
	}
	// ****************************************************************************************************
	// usuniecie QUERY z URL filtrowania
	// ****************************************************************************************************
	removeQueryFromUrlAfterFiltering(query){
		let that = this;
//console.log('Usuń query:',query, that.temporaryFilteringUrl);
		if ( that.temporaryFilteringUrl.includes('&') ) {
			that.temporaryFilteringUrl = that.temporaryFilteringUrl.replace('query='+query, '').replace('?&', '?'); //zakladam ze quey zawsze pierwsze
		} else {
			that.temporaryFilteringUrl = that.temporaryFilteringUrl.replace('?query='+query, '');
		}
//console.log('>>>>>>>>', that.temporaryFilteringUrl);
	}
	// ****************************************************************************************************
	// dodanie QUERY do URL filtrowania
	// ****************************************************************************************************
	addQueryToUrlAfterFiltering(query){
		let that = this;
//console.log('Dodaj query:',query, that.temporaryFilteringUrl);

		if ( that.temporaryFilteringUrl.includes('?') ) {
			that.temporaryFilteringUrl = that.temporaryFilteringUrl.replace('?', '?query='+query+'&');
		} else {
			that.temporaryFilteringUrl = that.temporaryFilteringUrl +'?query='+query;
		}
//console.log('>>>>>>>>', that.temporaryFilteringUrl);
	}
	// ****************************************************************************************************
	// usuniecie ATTR z URL filtrowania
	// ****************************************************************************************************
	removeFilterAttrAfterFiltering(input) {
		let that = this;
		let filterPrefix = that.getImportantFilterType(input);
		let filterVal = input.val();
		let url = toolsObj.decodeFullUrl(that.temporaryFilteringUrl);
		let newUrl = url.host;

//console.log('Usuń atrybut:',filterPrefix,' > ',filterVal, that.temporaryFilteringUrl);

		if ( url.path.includes(filterPrefix) && url.path.includes(filterVal) ) {
			url.path.split('/').forEach(function (item, index) {
				if ( !item.includes(filterPrefix) || ( item.includes(filterPrefix) && ( item.includes(','+filterVal) || item.includes(filterVal+',') ) ) ) {
					if ( item.includes(filterPrefix) ) {
						item = item.replace(','+filterVal, '').replace(filterVal+',', '');
					}
					newUrl += '/'+item;
				}
			});
			that.temporaryFilteringUrl = toolsObj.fixUrlOrder(newUrl)+url.search;
		}
	}
	// ****************************************************************************************************
	// Dodanie ATTR do URL filtrowania
	// ****************************************************************************************************
	addFilterAttrAfterFiltering(input){
		let that = this;
		let filterPrefix = that.getImportantFilterType(input);
		let filterVal = input.val();
		let url = toolsObj.decodeFullUrl(that.temporaryFilteringUrl);
		let newUrl = url.host;

//console.log('Dodaj atrybut:',filterPrefix,' > ',filterVal, that.temporaryFilteringUrl);

		if ( url.path.includes(filterPrefix) ) {
			url.path.split('/').forEach(function (item, index) {
				if ( item.includes(filterPrefix) ) {
					item = item+','+filterVal; // kolejnosc nie ma znaczena bo filtrowane wyniki nie sa indexowane
				}
				newUrl += '/'+item;
			});
		} else {
			newUrl = url.host + '/' + url.path + '/'+filterPrefix+'-'+filterVal;
		}
		that.temporaryFilteringUrl = toolsObj.fixUrlOrder(newUrl)+url.search;
	}
	// ****************************************************************************************************
	// ustalenie typu filtra specjalnego
	// ****************************************************************************************************
	getImportantFilterType(input){
		return (input.hasClass('filterInput-atwyprzedaz')) ? 'atw' : 'atm';
	}
	// ****************************************************************************************************
	// zamiana filtra na query
	// ****************************************************************************************************
	replaceFilteringWithQuery(input){
		let that = this;

		that.removeFilterAttrAfterFiltering(input);
		that.addQueryToUrlAfterFiltering(input.data('query'));
	}
	// ****************************************************************************************************
	// zamiana query na filtr
	// ****************************************************************************************************
	replaceQueryWithFiltering(query){
		let that = this;
		let queryBrandInput = $('.filterInput-marki[data-query="'+query+'"], .filterInput-atwyprzedaz[data-query="'+query+'"]');

		that.removeQueryFromUrlAfterFiltering(query);
		that.addFilterAttrAfterFiltering(queryBrandInput);
	}
	// ****************************************************************************************************
	// sprawdzenie czy filtr jest filtrem specjalnym
	// ****************************************************************************************************
	checkIfFilterIsImportant(input){
		return input.closest('.checkboxFilter').hasClass('importantFilter');
	}
	// ****************************************************************************************************
	// bsluga przyadku, gdy zostaje tylko 1 input specjalny
	// ****************************************************************************************************
	changeStateOfLastSpecialInput(input){
		let that = this;
		let lastBrandInput = $('.filterInput-marki:checked, .filterInput-atwyprzedaz:checked');

		if ( that.checkIfFilterIsImportant(lastBrandInput) ) {
			that.replaceFilteringWithQuery(lastBrandInput);
		}

		that.removeFilterAttrAfterFiltering(input);
	}
	// ****************************************************************************************************
	// Przygotowanie do przeładowania filtrowanie
	// ****************************************************************************************************
	prepareApplyFilters(key=0) {
		let that = this;

//console.log('prepareApplyFilters',key, that.temporaryFilteringUrl);
		if (pageObj.settings.bootstrap.kind == 'desktop')
			that.applyFilters(that.temporaryFilteringUrl);
		else
			that.checkVisibilityClearFiltersBtn();
	}
	// ****************************************************************************************************
	// inicjacja filtrów typu checkbox
	// ****************************************************************************************************
	initCheckboxFilters() {
		let that = this;
		that.checkboxFilters = $('.checkboxFilter');

		that.checkboxFilters.each(function (i, e) {
			let input = $(e).find('input');
			$(e).on('click', function () {
				let query = toolsObj.getUrlParameter('query');
				that.temporaryFilteringUrl = window.location.href;
//console.log('-----click-----',location.pathname, location.search, query, input.data('query'), input.is(':checked'), that.isQueryAnImportantFilter(query));

				if ( query == input.data('query') ) {
					if ( input.is(':checked') ) {
						toolsObj.changeInputState(input);

						if ( that.chechNumberOfActiveFilters('filterInput') == 0 ){
							if ( location.pathname.includes('cat-') ) {
								that.removeQueryFromUrlAfterFiltering(query);
								that.prepareApplyFilters('0');
							} else {
								window.location.href = '/';
							}
						} else {
							that.removeQueryFromUrlAfterFiltering(query);

							if ( that.chechNumberOfActiveFilters('filterInput-marki, .filterInput-atwyprzedaz') == 1 ) {
								that.changeStateOfLastSpecialInput(input);
							} else {
								that.removeFilterAttrAfterFiltering(input);
							}

							that.prepareApplyFilters('x567');
						}
					} else { // zaznaczam input bez reload (czyli jakis błąd, bo taka sytuacja nie powinna zaistnieć)
						toolsObj.changeInputState(input);
					}
				} else {
					if ( that.isQueryAnImportantFilter(query) || !query ) {
						if ( $(e).hasClass('filter_marki') || $(e).hasClass('filter_atwyprzedaz') ) {
							if ( input.is(':checked') ) {
								toolsObj.changeInputState(input);

								if ( that.chechNumberOfActiveFilters('filterInput-marki, .filterInput-atwyprzedaz') == 1 ) {
									that.changeStateOfLastSpecialInput(input);
								} else {
									that.removeFilterAttrAfterFiltering(input);
								}
							} else {
								toolsObj.changeInputState(input);

								if ( query ) {
									that.replaceQueryWithFiltering(query);

									if ( that.checkIfFilterIsImportant(input) )
										that.addFilterAttrAfterFiltering(input);
								} else {
									if ( that.chechNumberOfActiveFilters('filterInput-marki, .filterInput-atwyprzedaz') == 1 ) {
										that.changeStateOfLastSpecialInput(input);
									} else {
										if ( that.checkIfFilterIsImportant(input) )
											that.addFilterAttrAfterFiltering(input);
									}
								}
							}
						} else {
							toolsObj.changeInputState(input);
						}
					} else {
						toolsObj.changeInputState(input);
					}
					that.prepareApplyFilters('124567');
				}
				that.temporaryFilteringUrl = null;
			});

			input.on('click', function (event) {
				toolsObj.changeInputState(input); // podwojne klikniecie
			});
		});

		$('.brandSearchExt').each(function (i, e) { // wyłączenie klikalności linków marek wyróżnionych
			$(e).on('click', function (event) {
				event.preventDefault();
			});
		});
	}
	// ****************************************************************************************************
	// inicjacja filtrów typu checkbox
	// ****************************************************************************************************
	initPriceFilters() {
		var that = this;
		that.minPriceInput = $('#minPrice');
		that.maxPriceInput = $('#maxPrice');
		that.minPriceRangeInput = $('#rangeInputMinPrice');
		that.maxPriceRangeInput = $('#rangeInputMaxPrice');
		that.price.min = Number(that.minPriceRangeInput.attr('min'));
		that.price.setMin = Number(that.minPriceInput.val());
		that.price.max = Number(that.maxPriceRangeInput.attr('max'));
		that.price.setMax = Number(that.maxPriceInput.val());
		that.addPriceFiltersEvent();
		$('.priceFilterBtn').on('click', function () {
			if (Number(that.minPriceInput.val()) != that.price.setMin || Number(that.maxPriceInput.val()) != that.price.setMax) // blokada zatwierdzania filtu gdy zakres cen jest taki jak obecnie zaladowany
				that.applyFilters();
		});
	}
	// ****************************************************************************************************
	// inicjacja przycisków ukrywających i pokazujących nadmiar filtrów
	// ****************************************************************************************************
	initShowHideFiltersBtn() {
		var that = this;
		$('.moreFiltersBtn').each(function (i, e) {
			$(e).on('click', function () {
				var containerId = $(e).data('show-target');
				if ($(e).hasClass('showMoreFilters')) {
					$('#' + containerId + ' .hideFilter').hideUp(PRODUCTS_DETEILS_ANIMATION_SPEED, function () {
						$(e).removeClass('showMoreFilters');
					});
				}
				else {
					$('#' + containerId + ' .hideFilter').showDown(PRODUCTS_DETEILS_ANIMATION_SPEED, function () {
						$(e).addClass('showMoreFilters');
					});
				}
			});
		});
	}
	// ****************************************************************************************************
	// inicjacja filtrów typu checkbox
	// ****************************************************************************************************
	initClearFiltersBtn() {
		var that = this;
		that.clearFiltersBtn = $('#clearFilters');
		that.clearFiltersBtn.on('click', function () {
			that.uncheckCheckboxFilters();
			that.minPriceInput.val(that.price.min);
			that.maxPriceInput.val(that.price.max);
			that.updateRangeInputs();
			that.clearFiltersBtn.hide();
			if (pageObj.settings.bootstrap.kind == 'desktop')
				that.applyFilters();
		});
		that.checkVisibilityClearFiltersBtn();
	}
	// ****************************************************************************************************
	// dodanie do inptów ceny eventu change (powiazanie inputu text z range)
	// ****************************************************************************************************
	addPriceFiltersEvent() {
		var that = this;
		that.minPriceInput.change(function (event) {
			that.fixPriceFilters('min');
			that.updateRangeInputs();
		});
		that.maxPriceInput.change(function (event) {
			that.fixPriceFilters('max');
			that.updateRangeInputs();
		});
		that.minPriceRangeInput.on('input', function (event) {
			that.updatePriceInputs();
			if (that.fixPriceFilters('min')) {
				that.updateRangeInputs();
			}
		}).change(function () {
			$(this).trigger('input');
		});
		that.maxPriceRangeInput.on('input', function (event) {
			that.updatePriceInputs();
			if (that.fixPriceFilters('max')) {
				that.updateRangeInputs();
			}
		}).change(function () {
			$(this).trigger('input');
		});
		;
	}
	// ****************************************************************************************************
	// update range input
	// ****************************************************************************************************
	updateRangeInputs() {
		var that = this;
		that.minPriceRangeInput.val(that.minPriceInput.val());
		that.maxPriceRangeInput.val(that.maxPriceInput.val());
	}
	// ****************************************************************************************************
	// update input after range input change
	// ****************************************************************************************************
	updatePriceInputs() {
		var that = this;
		that.minPriceInput.val(that.minPriceRangeInput.val());
		that.maxPriceInput.val(that.maxPriceRangeInput.val());
		if (pageObj.settings.bootstrap.kind == 'mobile')
			that.checkVisibilityClearFiltersBtn();
	}
	// ****************************************************************************************************
	// sprawdzenie i skorygowanie wartosci filtrów ceny
	// ****************************************************************************************************
	fixPriceFilters(origin) {
		var that = this;
		var wasFix = false;
		var checkingMinValue, checkingMaxValue;
		checkingMinValue = Number(that.minPriceInput.val());
		checkingMaxValue = Number(that.maxPriceInput.val());
		// spr czy nie przekracza zakresow
		if (checkingMinValue < that.price.min) {
			that.minPriceInput.val(that.price.min);
			wasFix = true;
		}
		if (checkingMaxValue > that.price.max) {
			that.maxPriceInput.val(that.price.max);
			wasFix = true;
		}
		if (origin == 'min') {
			// POCHODZENIE input ceny minimalnej (text i range) - spr czy nie krzyżują się wartości min i max
			if (checkingMinValue >= checkingMaxValue) {
				if (checkingMinValue < that.price.max) {
					that.minPriceInput.val(checkingMinValue);
					that.maxPriceInput.val(checkingMinValue + 1);
				}
				else {
					that.minPriceInput.val(that.price.max - 1);
					that.maxPriceInput.val(that.price.max);
				}
				wasFix = true;
			}
		}
		else {
			// POCHODZENIE input ceny maksymalnej (text i range) - spr czy nie krzyżują się wartości min i max
			if (checkingMinValue >= checkingMaxValue) {
				if (checkingMaxValue > that.price.min) {
					that.minPriceInput.val(checkingMaxValue - 1);
					that.maxPriceInput.val(checkingMaxValue);
				}
				else {
					that.minPriceInput.val(that.price.min);
					that.maxPriceInput.val(that.price.min + 1);
				}
				wasFix = true;
			}
		}
		return wasFix; // FALSE = wszystko OK
	}
	// ****************************************************************************************************
	// odczytanie i ustawienie filtrów na podstawie URL
	// ****************************************************************************************************
	decodeFiltersFromUrlafterPopstate() {
		var that = this;
		var atributes;
		var filteringParams = toolsObj.getFilteringParamsFromUrl(location.pathname);
//console.log('decodeFiltersFromUrlafterPopstate -> filteringParams:',filteringParams);
		that.uncheckCheckboxFilters();
		filteringParams.split('/').forEach(function (param) {
			//console.log('param:',param);
			if (param.includes('atd-T')) {
				$('#atdost-T').prop('checked', true);
			}
			else if (param.includes('atn-T')) {
				$('#atnowosc-T').prop('checked', true);
			}
			else if (param.includes('atm-')) {
				atributes = param.replace('atm-', '');
				atributes.split(',').forEach(function (val) {
					//console.log('#marki-',val);
					$('#marki-' + val).prop('checked', true);
				});
			}
			else if (param.includes('attbc-')) {
				$('#atbezcen-T').prop('checked', true);
			}
			else if (param.includes('atw-')) {
				$('#atwyprzedaz-T').prop('checked', true);
			}
			else if (param.includes('f-')) {
				atributes = param.replace('f-', '');
				atributes.split(';').forEach(function (atribut) {
					//console.log('atribut:',atribut);
					atribut.split(':').forEach(function (filter) {
						if (!filter.includes('at')) {
							filter.split(',').forEach(function (val) {
								//console.log('#lista-',val);
								$('#lista-' + val).prop('checked', true);
							});
						}
					});
				});
			}
		});
		if (filteringParams.includes('atcmi-')) {
			that.minPriceInput.val(filteringParams.split('atcmi-')[1].split('/')[0]);
		}
		else {
			that.minPriceInput.val(that.minPriceRangeInput.attr('min'));
		}
		if (filteringParams.includes('atcma-')) {
			that.maxPriceInput.val(filteringParams.split('atcma-')[1].split('/')[0]);
		}
		else {
			that.maxPriceInput.val(that.maxPriceRangeInput.attr('max'));
		}
		that.updateRangeInputs();
		//console.log('decodeFiltersFromUrlafterPopstate', filteringParams);
	}
	// ****************************************************************************************************
	// odznaczenie filtrów typu checkbox
	// ****************************************************************************************************
	uncheckCheckboxFilters() {
		var that = this;
		that.checkboxFilters.each(function (i, e) {
			$(e).find('input').prop('checked', false).removeAttr('checked');
		});
	}
	// ****************************************************************************************************
	// sprawdzenie widocznośći przycisku czyszczenia filtrów
	// ****************************************************************************************************
	checkVisibilityClearFiltersBtn() {
		var that = this;
		var showBtn = false;
		that.checkboxFilters.each(function (i, e) {
			if ($(e).find('input').is(':checked'))
				showBtn = true;
		});
		if (that.price.min != Number(that.minPriceInput.val()))
			showBtn = true;
		if (that.price.max != Number(that.maxPriceInput.val()))
			showBtn = true;
		if (showBtn)
			that.clearFiltersBtn.show();
		else
			that.clearFiltersBtn.hide();
		//console.log(showBtn,that.price.min, that.price.setMin);
	}
	// ****************************************************************************************************
	// przygotowanie parametrow filtrowania
	// ****************************************************************************************************
	prepareFilteringParams(locationSerach) {
//console.log('prepareFilteringParams');
		var that = this;
		var brands = '', filters = '', minPrice = '', maxPrice = '', availability = '', newness = '', priceless = '', sales = '', inputs, groups, atLeastOneInputChecked = false, atLeastOneGroupChecked = false;
		let query = 'n/a';

		let tmp = locationSerach;

		if ( locationSerach.includes('query=') ) {
			locationSerach = locationSerach.replace('?', '');
			if ( locationSerach.includes('&') ) {
				locationSerach.split('&').forEach(function (item, index) {
					if ( item.includes('query=') ) {
						query = item.replace('query=', '');
					}
				});
			} else {
				query = locationSerach.replace('query=', '');
			}
		}
//console.log('prepareFilteringParams',tmp, query);
		inputs = $('.filterInput-marki');
		if (inputs.length > 0) {
			inputs.each(function (i, e) {
				if ( $(e).is(':checked') && $(e).data('query') != query && !$(e).hasClass('filter_atwyprzedaz') ) {
					if (atLeastOneInputChecked) {
						brands += ',' + $(e).val();
					} else {
						atLeastOneInputChecked = true;
						brands += '/atm-' + $(e).val();
					}
				}
			});
		}
		//filtry 'dynamiczne'
		groups = $('.filters-nv, .filters-bv, .filters-sl');
		if (groups.length > 0) {
			groups.each(function (j, g) {
				var atId = $(g).data('at-id');
				var atType = $(g).data('at-type'); // NV, BV, SL byc moze bedzie trzeba inaczej tworzyc link
				atLeastOneInputChecked = false;
				inputs = $(g).find('.filterInput-lista, .filterInput-wartosc'); // zrobione pod NV - ToDo: spr czy inne typy też tu działają
				if (inputs.length > 0) {
					inputs.each(function (i, e) {
						if ($(e).is(':checked')) {
							if (atLeastOneInputChecked) {
								filters += ',' + $(e).val();
							}
							else {
								if (atLeastOneGroupChecked) {
									filters += ';';
								}
								else {
									filters += '/f-';
									atLeastOneGroupChecked = true;
								}
								atLeastOneInputChecked = true;
								filters += 'at' + atId + ':' + $(e).val();
							}
						}
					});
				}
			});
		}
		if ( that.price.min != that.price.setMin )
			minPrice = '/atcmi-' + that.price.setMin; // cena min
		if ( that.price.max != that.price.setMax )
			maxPrice = '/atcma-' + that.price.setMax; // cena max
		if ( $('.filterInput-atdost').first().is(':checked') )
			availability = '/atd-T'; // dostepnosc
		if ( $('.filterInput-atnowosc').first().is(':checked') )
			newness = '/atn-T'; // nowosc
		if ( $('.filterInput-atbezcen').first().is(':checked') )
			priceless = '/attbc-T'; // bez cen
		if ( $('.filterInput-atwyprzedaz').first().is(':checked') && $('.filterInput-atwyprzedaz').data('query') != query )
			sales = '/atw-T'; // wyprzedaz

		return brands + filters + minPrice + maxPrice + availability + newness + priceless + sales;
	}
	// ****************************************************************************************************
	// zastosuj filtry
	// ****************************************************************************************************
	applyFilters(url = null) {
		var that = this;
		that.price.setMin = Number(that.minPriceInput.val());
		that.price.setMax = Number(that.maxPriceInput.val());
		that.actualPage = 1; // zresetowanie paginacji

		if ( url )
			that.loadProductsListing({ forceAjaxPageLoad: true, preparedListingUrl: url });
		else
			that.loadProductsListing({ forceAjaxPageLoad: true });
	}
	// ****************************************************************************************************
	// update linków po filtrowaniu
	// ****************************************************************************************************
	updateHrefInLinksAfterFiltering(linksObjList) {
		var that = this;
		var filteringParams = toolsObj.getFilteringParamsFromUrl(location.pathname);
		let hrefSplit, query, tmpfilteringParams, queryBrandInput, inputs;
//console.log('updateHrefInLinksAfterFiltering', filteringParams);

		if ( location.search.includes('query=') ) {
			if ( location.search.includes('?') ) {
				location.search.split('?').forEach(function (item, index) {
					if ( item.includes('query=') ) {
						query = item.replace('query=', '');
					}
				});
			} else {
				query = location.search.replace('query=', '');
			}
//console.log('updateHrefInLinksAfterFiltering is QUERY:', query);

			if ( query == 'outlet' ){
				filteringParams = filteringParams.replace('/atw-T', '');
//console.log('1', filteringParams);
			} else {
				queryBrandInput = $('.filterInput-marki[data-query="'+query+'"]');
				if ( queryBrandInput.length == 1 && queryBrandInput.is(':checked') ) {
					inputs = $('.filterInput-marki:checked');
					if ( inputs.length == 1 ) {
						filteringParams = filteringParams.replace('/atm-'+queryBrandInput.val(), '');
//console.log('2', filteringParams);
					} else {
						tmpfilteringParams = filteringParams.split('/');
						filteringParams = '';

						tmpfilteringParams.each(function (item, e) {
							if ( href.item('atm-') ) {
								item = item.replace(','+queryBrandInput.val(),'', queryBrandInput.val()+',','')
							}
							filteringParams += '/'+item;
						});
//console.log('3', filteringParams);
					}
				}
			}
		}

		linksObjList.each(function (i, e) {
			var href = $(e).attr('href');
			if ( href.includes('?') ) {
				hrefSplit = href.split('?');
				href = hrefSplit[0];
			}
//if ($(e).hasClass('currentLanguage')) {
//	console.log('href PRZED:', href);
//	console.log('href after remove', toolsObj.removeFiltersParameterFromUrl(href));
//	console.log('href new', toolsObj.removeFiltersParameterFromUrl(href) + filteringParams + location.search);
//}

			href = toolsObj.removeFiltersParameterFromUrl(href);
			// nowosci
//console.log('href', href, filteringParams);
			if ( window.location.href.includes('/new') && $('#atnowosc-T').is(':checked') ){
				href = href.replace('/items', '/new').replace('/atn-T', '');
				if ( href.includes('/at') ) {
					href = href.replace('/new', '/items/atn-T')
				}
				filteringParams = filteringParams.replace('/atn-T', '');
//console.log('href1', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));
			} else if ( window.location.href.includes('/items') && $('#atnowosc-T').is(':checked') ){
				href = href.replace('/new', '/items');
//console.log('href2', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));
			} // nowosci



			href = href + filteringParams + location.search;
			$(e).attr('href', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));
		});
	}
	// ****************************************************************************************************
	// Responsywnosc - dostosowanie filtrowania
	// ****************************************************************************************************
	adjustFilteringToViewKind() {
//console.log('adjustFilteringToViewKind');
		var that = this;
		if (pageObj.settings.bootstrap.kind == 'desktop') {
			$(that.desktopContId).append($(that.filtersCont));
			that.minPriceInput.removeAttr('readonly');
			that.maxPriceInput.removeAttr('readonly');
			that.clearFiltersBtn.addClass('sticky-bottom mt-3');
			$(that.desktopContId).append(that.clearFiltersBtn);
		} else {
			$(that.mobileContId).append($(that.filtersCont));
			that.minPriceInput.attr('readonly', 'readonly');
			that.maxPriceInput.attr('readonly', 'readonly');
			that.clearFiltersBtn.removeClass('sticky-bottom mt-3');
			$(that.mobileBtnsContId).prepend(that.clearFiltersBtn);

			$('#mobileFilteringModal').on('shown.bs.modal', function (e) {
				if (toolsObj.checkOverflowY('#mobileFilteringModal #mobileFilteringData')) {
					$('#mobileFilteringModal .modal-footer').before('<p class="overflowMarker"></p>');
				}
			});
			$('#mobileFilteringModal').on('hide.bs.modal', function (e) {
				$('#mobileFilteringModal .overflowMarker').remove();
			});
		}
	}
	// ****************************************************************************************************
	// Wyznaczenie ilości aktywnych filtrów
	// ****************************************************************************************************
	chechNumberOfActiveFilters(typeByClass) {
		var counter = 0;
		var filters = $('.'+typeByClass);

		filters.each(function (i, e) {
			if ( $(e).is(':checked') ) {
				counter ++;
			}
		});
		return counter;
	}
	// ****************************************************************************************************
	// Sprawdzenie, czy query jest promowaną marką
	// ****************************************************************************************************
	isQueryAnImportantFilter(query) {
		var res = false;

		$('.importantFilter input').each(function (i, e) {
			if ( $(e).data('query') == query ) {
				res = true;
				return;
			}
		});
		return res;
	}

}